import { gql } from '@apollo/client';

import META_FRAGMENT from '../fragments/meta';

export const GET_COMPANY_LOCATION = gql`
  ${META_FRAGMENT}
  query findLocation($query: String, $pagination: PageOptionsDto) {
    findLocationEntity(query: $query, pagination: $pagination) {
      data {
        id
        name
        address
        number
        returnShippingAccount
        usersLocations {
          id
          clientPermission
          manageUsersPermission
          user {
            id
            firstName
            lastName
            avatar {
              id
              thumbnailPipeFrom
            }
          }
        }
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;
